import { render, staticRenderFns } from "./Unbox.vue?vue&type=template&id=40158fa6&scoped=true"
import script from "./Unbox.vue?vue&type=script&lang=js"
export * from "./Unbox.vue?vue&type=script&lang=js"
import style0 from "./Unbox.vue?vue&type=style&index=0&id=40158fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40158fa6",
  null
  
)

export default component.exports